"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notRun = exports.failureChanges = exports.failure = exports.successChanges = exports.success = exports.size = exports.wrench = exports.barChart = exports.coins = exports.lineChart = exports.document = exports.report = exports.weather = exports.cog = exports.brick = void 0;
// biome-ignore lint: -
exports.brick = require("../../../../assets/images/workflow/brick.png");
// biome-ignore lint: -
exports.cog = require("../../../../assets/images/workflow/cog.png");
// biome-ignore lint: -
exports.weather = require("../../../../assets/images/workflow/weather.png");
// biome-ignore lint: -
exports.report = require("../../../../assets/images/workflow/report.png");
// biome-ignore lint: -
exports.document = require("../../../../assets/images/workflow/document.png");
// biome-ignore lint: -
exports.lineChart = require("../../../../assets/images/workflow/line-chart.png");
// biome-ignore lint: -
exports.coins = require("../../../../assets/images/workflow/coins.png");
// biome-ignore lint: -
exports.barChart = require("../../../../assets/images/workflow/bar-chart.png");
// biome-ignore lint: -
exports.wrench = require("../../../../assets/images/workflow/wrench.png");
// biome-ignore lint: -
exports.size = require("../../../../assets/images/workflow/size.png");
// biome-ignore lint: -
exports.success = require("../../../../assets/images/workflow/success.svg");
// biome-ignore lint: -
exports.successChanges = require("../../../../assets/images/workflow/success-changes.svg");
// biome-ignore lint: -
exports.failure = require("../../../../assets/images/workflow/failure.svg");
// biome-ignore lint: -
exports.failureChanges = require("../../../../assets/images/workflow/failure-changes.svg");
// biome-ignore lint: -
exports.notRun = require("../../../../assets/images/workflow/not-run.svg");
//# sourceMappingURL=workflow.js.map